import hash from 'object-hash';

import {
  ReportComponentDataProps,
  ReportDashboardComponentKind,
  ReportDashboardMetricOptions,
  ReportResultsDataParams,
} from '@core/reports-types';

import { encodeFiltersQuery } from '../index';

// TODO shared-analytics - this should be part of internal API of results facade
// On the backend these params are always set on the component if we do not provide it.
// We actually do not provided as in the component builder only properties that make sense are set.
// This fallback ensures that saved component and component in edit mode have the same params hash
// Now builder component will update alongside the saved component when dashboard refreshes.
// See task #863gt1f1c
export const buildApiDataParamsHash = (params: ReportResultsDataParams) => hash.sha1({ params });

const normalizeComponentOpts = (component: ReportComponentDataProps): ReportComponentDataProps => ({
  ...component,
  options: {
    ...component.options,
    includeArchivedJobs: component.options.includeArchivedJobs ?? true,
    includeArchivedRequisitions: component.options.includeArchivedRequisitions ?? true,
    includeDeletedCandidates: component.options.includeDeletedCandidates ?? false,
    showAllData: component.options.showAllData ?? false,
  },
});
const getComponentApiDataParams = (
  component: ReportComponentDataProps,
  metric?: ReportDashboardMetricOptions,
): ReportResultsDataParams => ({
  metric: component.metric,
  includeDeletedCandidates: component.options.includeDeletedCandidates,
  includeArchivedJobs: component.options.includeArchivedJobs,
  includeArchivedRequisitions: component.options.includeArchivedRequisitions,
  showAllData: component.options.showAllData,
  primaryGroup: component.primaryGroup,
  secondaryGroup: component.secondaryGroup,
  sortBy: component.sortBy,
  sortOrder: component.sortOrder,
  filters: encodeFiltersQuery(component.filters || []),
  interval: component.settings?.interval,
  dateField: component.dateField?.field,
  dateResource: component.dateField?.resource,
  unitPrecision: metric?.unitPrecision,
  ...(component.options.showAllData
    ? {
        dateRange: null,
        dateStart: null,
        dateEnd: null,
      }
    : component.dateFilter),
  ...(component.kind === ReportDashboardComponentKind.TimeBased && {
    startPoint: component.startPoint,
    endPoint: component.endPoint,
  }),
});
export const buildApiDataParams = (
  component: ReportComponentDataProps,
  metric?: ReportDashboardMetricOptions,
): ReportResultsDataParams => {
  const componentData = normalizeComponentOpts(component);
  return getComponentApiDataParams(componentData, metric);
};
